/* Site-wide script fixes (was inline in snippets/styling-update.liquid). Deferred; runs its work from DOMContentLoaded. */
// Runs from DOMContentLoaded so the deferred jQuery/Slick are available
document.addEventListener('DOMContentLoaded', function() {
  // Function to initialize the slider
  function initSlider() {
    // Check if the holding div exists
    const holderDiv = document.querySelector('.col-md-36.shop-the-look__products .row.justify-content-center');
    
    if (!holderDiv) {
      console.log('Holder div not found');
      return;
    }
    
    // FIRST: Move out the .col-60 div BEFORE counting slides
    const excludeDiv = holderDiv.querySelector('.col-60');
    const parentContainer = holderDiv.parentNode;
    
    if (excludeDiv) {
      // Remove it completely from the row
      excludeDiv.remove();
    }
    
    // NOW get all the slide divs (after removing .col-60)
    const slideDivs = holderDiv.querySelectorAll('.col-md-20.shop-the-look__products-media');
    
    if (slideDivs.length === 0) {
      console.log('No slide divs found');
      return;
    }
    
    // Only initialize if more than 3 divs
    if (slideDivs.length > 2) {
      // Add CSS BEFORE initializing Slick
      const style = document.createElement('style');
      style.textContent = `
        .slick-slider-holder {
          justify-content: flex-start !important;
        }
        .slick-slider-holder .slick-slide {
          float: left !important;
          display: inline-block !important;
          vertical-align: top !important;
        }
        .slick-slider-holder .slick-track {
          display: flex !important;
          align-items: flex-start !important;
        }
        .slick-slider-holder .slick-list {
          overflow: hidden !important;
        }
        .col-md-36.shop-the-look__products > .col-60 {
          width: 100% !important;
          margin-top: 20px !important;
          flex: 0 0 100% !important;
          max-width: 100% !important;
          display: block !important;
          clear: both !important;
        }
      `;
      document.head.appendChild(style);
      
      // Add slick slider class to holder
      holderDiv.classList.add('slick-slider-holder');
      
      // Initialize Slick
      $(holderDiv).slick({
        infinite: false,
        slidesToShow: 2.25,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        centerMode: false,
        variableWidth: false,
        nextArrow:
          '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" role="img" width="24px" height="24px" fill="none"><path stroke="currentColor" stroke-width="1.5" d="M8.474 18.966L15.44 12 8.474 5.033"></path></svg></button>',
        prevArrow:
          '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" role="img" width="24px" height="24px" fill="none"><path stroke="currentColor" stroke-width="1.5" d="M15.525 18.966L8.558 12l6.967-6.967"></path></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.25,
              slidesToScroll: 1,
              centerMode: false
            }
          }
        ]
      });
      
      // Re-append the button AFTER Slick is initialized
      if (excludeDiv) {
        parentContainer.appendChild(excludeDiv);
      }
      
      console.log('Slick slider initialized with ' + slideDivs.length + ' slides');
    } else {
      // If not enough slides, still move the button
      if (excludeDiv) {
        parentContainer.appendChild(excludeDiv);
      }
      console.log('Not enough slides (' + slideDivs.length + '), slider not initialized');
    }
  }
  
  // Nothing to do (and no Slick to download) unless the shop-the-look block is on this page
  if (!document.querySelector('.col-md-36.shop-the-look__products .row.justify-content-center')) return;

  // Check if jQuery is loaded
  if (typeof jQuery === 'undefined') {
    console.error('jQuery is required but not loaded');
    return;
  }
  
  // Check if Slick is already loaded
  if (typeof jQuery.fn.slick !== 'undefined') {
    console.log('Slick already loaded');
    initSlider();
  } else {
    console.log('Loading Slick...');
    
    // Load Slick CSS
    const slickCSS = document.createElement('link');
    slickCSS.rel = 'stylesheet';
    slickCSS.href = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css';
    document.head.appendChild(slickCSS);
    
    const slickThemeCSS = document.createElement('link');
    slickThemeCSS.rel = 'stylesheet';
    slickThemeCSS.href = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css';
    document.head.appendChild(slickThemeCSS);
    
    // Load Slick JS
    const slickJS = document.createElement('script');
    slickJS.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
    slickJS.onload = function() {
      console.log('Slick loaded successfully');
      initSlider();
    };
    slickJS.onerror = function() {
      console.error('Failed to load Slick');
    };
    document.head.appendChild(slickJS);
  }
});



document.addEventListener('DOMContentLoaded', function () {
  $('.shop-the-look__products-media').click(function(){
    $('.product-popup-modal__button').click();
  });
  $('.shop-the-look__image').click(function(){
    $('.product-popup-modal__button').click();
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('imageModal');
  const modalImg = document.getElementById('modalImage');
  const closeBtn = document.querySelector('.image-modal__close');
  
  // Only target shop_the_look media divs within product-popup-modal__content
  const mediaDivs = document.querySelectorAll('.product-popup-modal__content .shop_the_look__media');
  
  mediaDivs.forEach(function(div) {
    div.addEventListener('click', function() {
      const img = this.querySelector('img');
      if (img) {
        modal.style.display = 'block';
        // Get the full-size image (last source in srcset or src)
        const srcset = img.getAttribute('srcset');
        let fullSizeUrl = img.src;
        
        if (srcset) {
          const sources = srcset.split(',');
          const lastSource = sources[sources.length - 1].trim().split(' ')[0];
          fullSizeUrl = lastSource;
        }
        
        modalImg.src = fullSizeUrl;
        // Prevent body scroll when modal is open
        document.body.style.overflow = 'hidden';
      }
    });
  });
  
  // Close modal function
  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
  
  // Close modal when clicking the X
  closeBtn.addEventListener('click', closeModal);
  
  // Close modal when clicking outside the image
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      closeModal();
    }
  });
  
  // Close modal with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'block') {
      closeModal();
    }
  });
});
